<ng-template #StornoSuccess>
  <div class="modal-success-storno">
    <div nxRow>
      <div nxCol="12" style="text-align: center;">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold"
          translate>
          policy.storno.modal.success.title</h3>
          <h4 nxHeadline="subsection-xsmall" translate>
            policy.storno.modal.success.text
          </h4>
      </div>
    </div>
    <div nxRow>
      <div nxCol="12" style="text-align: center;">
        <button nxButton="primary normal" type="button"
        (click)="closeModal()"><span
          translate>policy.storno.modal.success.submit</span></button>
      </div>
    </div>
  </div>
</ng-template>
